import { useTranslation } from "react-i18next";
import Layout from "@/components/feature/Layout";
import SEO from "@/components/feature/SEO";
import ServicePageLayout from "./components/ServicePageLayout";
import { hvacData } from "@/mocks/services";

export default function HvacPage() {
  const { t } = useTranslation("home");

  return (
    <Layout>
      <SEO
        title="Servicios HVAC en León, Guanajuato | Ventra Core"
        description="Venta, instalación y mantenimiento de sistemas HVAC: calefacción, ventilación, aire acondicionado, aires de precisión y eficiencia energética en León, Guanajuato."
        keywords="HVAC, calefacción, ventilación, aire acondicionado, aires de precisión, eficiencia energética, climatización León, sistemas HVAC Guanajuato"
        canonical="https://ventracore.com.mx/hvac"
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "@id": "https://ventracore.com.mx/hvac#service",
            "serviceType": "HVAC - Calefacción, Ventilación y Aire Acondicionado",
            "provider": { "@id": "https://ventracore.com.mx/#organization" },
            "areaServed": {
              "@type": "City",
              "name": "León",
            },
            "description": "Venta, instalación y mantenimiento de sistemas HVAC en León, Guanajuato.",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": "https://ventracore.com.mx/",
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Servicios",
                "item": "https://ventracore.com.mx/servicios",
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "HVAC",
                "item": "https://ventracore.com.mx/hvac",
              },
            ],
          },
        ]}
      />
      <ServicePageLayout
        title={t("servicesPage.hvacTitle")}
        subtitle={t("servicesPage.hvacSubtitle")}
      >
        <div className="max-w-5xl mx-auto">
          <p className="text-sm md:text-base text-text-muted leading-relaxed text-center mb-10 md:mb-14">
            {hvacData.intro}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {hvacData.features.map((f) => (
              <div
                key={f.title}
                className="bg-surface rounded-lg p-5 md:p-6 border border-transparent hover:border-brandgreen/20 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-brandgreen/10 rounded-md mb-4">
                  <span className="w-6 h-6 flex items-center justify-center text-brandgreen">
                    <i className={f.icon} />
                  </span>
                </div>
                <h4 className="text-base font-bold text-magenta mb-2">
                  {f.title}
                </h4>
                <p className="text-sm text-text-muted leading-relaxed">
                  {f.description}
                </p>
              </div>
            ))}
          </div>

          <p className="text-sm text-text-muted text-center mt-10 md:mt-14">
            {hvacData.contact}
          </p>
        </div>
      </ServicePageLayout>
    </Layout>
  );
}